import SegmentedControl from './SegmentedControl'

export default SegmentedControl
